const agent = {
  name: 'John Snippen',
  office: 'RE/MAX Key Properties',
  phone: '(541) 948-9090',
  email: 'john@snippen.com',
  address: '42 NW Greenwood Ave. Bend, OR 97703',
  sparkAgentId: '20200218205934419718000000',
  headshotUrl: '/images/john-headshot.jpg', // Locally hosted agent headshot
};
export default agent;
